import React from "react";
import "./MoreFeatures.css";
import Heading from "./Heading";
import Description from "./Description";
import SubHeading from "./SubHeading";

const MoreFeatures = ({ data}) => {
  return (
    <section className="more-features-wrapper py-5" data-aos="fade-up">
      <div className="container">
        <div className="text-center mb-5">
          <Heading className="mb-2">More Features</Heading>
        </div>

        <div className="row g-4">
          {data.map((data, index) => {
            return (
              <div className="col-12 col-md-6 col-lg-4" key={index}>
                <div className="feature-card h-100">
                    {/* <div className="feature-card-top"> */}
                      {/* <div className="activity-widget-img-wrap"> */}
                        <img
                          src={data.Image}
                          alt="Activity timer"
                          className="activity-img"
                        />
                      {/* </div> */}
                    {/* </div> */}
                    <div className="content-padding">
                      <SubHeading className="text-start mb-2 fw-semibold">
                        {data.title}
                      </SubHeading>
                      <Description className="text-start mb-0">
                        {data.desc}
                      </Description>
                    </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MoreFeatures;
